var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamMemberBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 463,
    viewBox: "0 0 389 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.518555,
    y: 0.455078,
    width: 388,
    height: 462,
    rx: 20,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.003 301.934C171.564 301.934 148.126 301.934 124.688 301.934C123.543 301.934 122.383 301.934 121.233 301.816C115.366 301.268 113.007 297.315 115.509 291.97C117.68 287.356 120.049 282.86 122.349 278.295C133.206 256.801 144.063 235.311 154.92 213.824C155.256 213.167 155.606 212.511 155.996 211.884C158.73 207.502 163.172 206.885 166.67 210.665C169.138 213.311 171.226 216.281 173.427 219.149C184.613 233.766 195.799 248.39 206.985 263.021C211.871 269.387 218.025 269.733 223.764 264.008C226.612 261.166 229.395 258.249 232.277 255.431C237.474 250.348 243.371 250.654 247.615 256.581C256.133 268.474 264.439 280.526 272.784 292.538C273.436 293.48 273.936 294.519 274.264 295.617C275.074 298.376 273.929 300.597 271.131 301.332C269.376 301.752 267.575 301.946 265.771 301.909C242.195 301.949 218.605 301.957 195.003 301.934Z",
    fill: "#CBCBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247.566 184.159C247.56 188.747 246.192 193.23 243.635 197.039C241.078 200.848 237.448 203.812 233.205 205.556C228.961 207.299 224.296 207.744 219.799 206.833C215.303 205.921 211.179 203.695 207.949 200.437C204.719 197.179 202.53 193.035 201.658 188.531C200.786 184.027 201.271 179.366 203.052 175.138C204.832 170.91 207.828 167.305 211.66 164.782C215.491 162.259 219.986 160.93 224.573 160.965C230.682 161.042 236.516 163.517 240.817 167.856C245.118 172.195 247.542 178.05 247.566 184.159Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMemberBlank);
export default __webpack_public_path__ + "static/media/team-member-blank.2cd84ea9821de42a0b30d4034be6c59d.svg";
export { ForwardRef as ReactComponent };